/* eslint-disable
    func-names,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./categorizer.scss');

const co = require('co');

const deps = [
  'bench.main-app',
  require('angular-ui-router'),
  require('./rule').name,
  require('ui/web/categorizer/categorizerTable').name,
  require('ui/web/categorizer/categorizerNavbar').name,
  require('ui/web/categorizer/categorizerRulesUpload').name,
  require('ui/web/categorizer/categorizerRuleInput').name,
  require('ui/web/subnavbar').name,
  require('ui/web/notifications').name,
  require('ui/web/constants').name,
];

module.exports = angular
  .module('bench.app.mainapp.categorizer', deps)

  .factory('uiStateConfig', () => ({}))

  .config(($stateProvider, MainAppConfig) => {
    const stateName = 'bench.categorizer';
    const path = MainAppConfig.routes[stateName];

    return $stateProvider.state(stateName, {
      url: path,
      resolve: {
        _rules(_User, CategorizerRuleCollection, $stateParams) {
          return co(function* () {
            const clientId = _User.getClientId();

            const rules = new CategorizerRuleCollection(clientId);
            yield rules.$promise;

            return rules;
          });
        },
      },
      views: {
        '': {
          controller($state, _rules, uiStateConfig) {
            this.rulesId = _rules.$storeId();
            this.state = $state;
            this.config = uiStateConfig;

            return this;
          },
          controllerAs: 'vm',
          template: `\
<categorizer-content>
  <div class="content_header">
    <bl-categorizer-navbar
      rules-id="vm.rulesId">
    </bl-categorizer-navbar>
  </div>
  <div class="content_body">
    <div ng-class="vm.config.detailsBar ? 'details-bar-open' : 'details-bar-closed'">
      <ui-view name="details-bar" class="bl-animate categorizer-details"></ui-view>
    </div>
    <div class="content_body_table">
      <bl-categorizer-table
        client-id="vm.rulesId"
      >
      </bl-categorizer-table>
    </div>
  </div>
</categorizer-content>\
`,
        },
      },
    });
  });
